import React, { useState } from "react";

import { FormControl, IconButton, InputAdornment, InputLabel, OutlinedInput, Skeleton, styled } from '@material-ui/core';
import IconSend from '@material-ui/icons/Send';
import { StringParam, useQueryParam } from "use-query-params";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../store";
import { actions } from '../../services/support';


const Root = styled('div')({

});

const MessageInputBox: React.FC = () => {
  const [ selectedChat ] = useQueryParam('id', StringParam);

  const state = useSelector((state: RootState) => state.support);
  const dispatch = useDispatch();

  const [ message, setMessage ] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setMessage(event.target.value);
  };



  const chat = state.chats.find(item => item.id === selectedChat);

  if (!selectedChat) {
    return null;
  }

  if (!chat) {
    return <Skeleton variant="text" />
  }

  const onSendMessage = () => {
    dispatch(actions.sendMessage({
      chat,
      message
    }));
    setMessage('');
  }

  return (
    <Root>
      <FormControl sx={{ width: '100%' }} variant="outlined">
        <InputLabel htmlFor="send-label">Send a message</InputLabel>
        <OutlinedInput
          id="send-label"
          multiline
          maxRows={5}
          value={message}
          onChange={handleChange}
          endAdornment={
            <InputAdornment position="end">
              <IconButton
                edge="end"
                disabled={message.trim().length < 2}
                color="secondary"
                onClick={onSendMessage}
              >
                <IconSend />
              </IconButton>
            </InputAdornment>
          }
          label="Send a message"
        />
      </FormControl>
    </Root>
  );
};

export default MessageInputBox;